import React from 'react';
import FormGroup from 'react-bootstrap/FormGroup';
import FormLabel from 'react-bootstrap/FormLabel';
import A11yFontIcon from 'components/A11yFontIcon';
import BackArrow from 'components/AuthHeader/assets/Icon-Back.png';
import TextButton from 'components/TextButton';

export const FORM_NAME = 'signUpForm';

export const ASYNC_VALIDATION_FIELDS = ['email', 'displayName', 'password'];

const SIGN_UP_GENDER_OPTIONS = ['male', 'female', 'other'];
export const GENDER_OPTIONS = SIGN_UP_GENDER_OPTIONS.map(gender => ({
  value: gender,
  label: gender.charAt(0).toUpperCase() + gender.slice(1)
}));

const SIGN_UP_LANGUAGE_OPTIONS = {
  en: 'English',
  es: 'Español'
};
export const LANGUAGE_OPTIONS = Object.entries(SIGN_UP_LANGUAGE_OPTIONS).map(
  ([value, label]) => ({
    value,
    label
  })
);

export const HorizontalRule = () => <div className="form-horizontal-rule" />;

export const BackButton = ({ className, onClick }) => {
  return (
    <button
      className={`back-button ${className}`}
      onClick={onClick}
      type="button"
    >
      <img src={BackArrow} alt="Go Back" />
    </button>
  );
};

export const CellSpan = props => (
  <div className="cell-span input-container" {...props} />
);

export const ReadOnlyInput = props => (
  <div className={`input-container read-only-input ${props.className || ''}`}>
    <FormGroup>
      <FormLabel>{props.label}</FormLabel>
      <div className="form-control read-only-control">{props.children}</div>
    </FormGroup>
  </div>
);

export const SubmitStatus = props => (
  <div className="submit-status">
    {props.submitting && (
      <A11yFontIcon icon="spinner" pulse fixed alt="Processing" />
    )}
  </div>
);

export const TermsOfServiceLink = ({ onClick }) => (
  <div>
    <span aria-hidden="true">I have read and agree to the </span>
    <span className="sr-only">
      I have read and agree to the Terms of Service
    </span>
    <TextButton
      underline
      className="tos-link"
      onClick={onClick}
      aria-label="View Terms of Service"
    >
      terms&nbsp;of&nbsp;service
    </TextButton>
  </div>
);

export const FaqLink = ({ onClick }) => (
  <div className="faq-container">
    <span aria-hidden="true">Read more in our membership </span>
    <span className="sr-only">Read more in our membership FAQ</span>
    <TextButton
      underline
      className="faq-link"
      onClick={onClick}
      aria-label="View Frequently Asked Questions"
    >
      FAQs
    </TextButton>
  </div>
);
